var i18nLib = require("../i18n");
var aux = require("./__aux");

var searchCache = {};

$(document).ready(function () {
	// Prevent search bar feature on search results page
	var pathBuilder = [location.protocol, '', location.host];
	var searchPath;
	if ((searchPath = $('#searchPath').val())) {
		pathBuilder.push(searchPath);
	}
	var localSearchPath = pathBuilder.join('/');
	if (aux.clearUrlAnchor(aux.clearUrlQuery(location.href)) === aux.clearUrlAnchor(localSearchPath)) {
		$('#search__link--autocomplete').remove();
		$('.header__wrapper > .header__search ').remove();
	}

	var changeEventsForMobile = function () {
		var isMobile = aux.isMobile();
		if (isMobile === window.isMobileAutocomplete)
			return; // Prevent false-positives

		if (!isMobile) {
			window.isMobileAutocomplete = false;
			$('#search-link').attr('id', 'search__link--autocomplete');
			// Open and close search box
			$('#search__link--autocomplete').off('click');
			$('#search__link--autocomplete').click(openAutocomplete);
			$('#search__link--autocomplete a').removeClass('hidden')
			$('.header__search--after').off('click');
			$('.header__search--after').click(closeAutocomplete);
		} else {
			window.isMobileAutocomplete = true;
			$('#search__link--autocomplete a').removeClass('hidden')
			$('#search__link--autocomplete').off('click')
			$('#search__link--autocomplete').attr('id', 'search-link');
		}
	};
	changeEventsForMobile({ type: 'inline' });
	$(window).resize(aux.debounce(changeEventsForMobile, 100));

	// Enable auto redirecting to fullpage
	var fullpageAutoLoad = function (autocompleteData) {
		if (autocompleteData && autocompleteData.fullpageAnchor) {
			autocompleteData.fullpageAnchor.trigger('mousedown');
		}
	};

	var rebuildAutocompleteEvents = function () {
		//TODO:
	};

	// Autocomplete
	var autocompleteEventCallback = aux.debounce(function (event) {
		var $this = $(this);
		var start = 0;
		var pageSize = 6;
		var searchTerm = ($this.val() || '').trim();
		// Clear autocomplete when ESC is pressed or there are no searchTerm
		if (event.which === 27 /*ESC*/ || !searchTerm) {
			$this.val('');
			handleAutocomplete(null);
		} else if (aux.isInputKey(event.which)) {
			var isFullpageAuto = (event.which === 13);
			if (searchCache[searchTerm]) {
				handleAutocomplete(searchCache[searchTerm]).then(isFullpageAuto ? fullpageAutoLoad : rebuildAutocompleteEvents);
			} else if (searchTerm.length >= 2) {
				var addSpinner = () => { $('.header__search--before').addClass('bg-spinner-b'); };
				var removeSpinner = () => { $('.header__search--before').removeClass('bg-spinner-b'); };

				addSpinner();
				asyncSearch(searchTerm, start, pageSize, function (result) {
					handleAutocomplete(result).then(isFullpageAuto ? fullpageAutoLoad : rebuildAutocompleteEvents);
					removeSpinner();
				}, removeSpinner);
			}
		}
	}, 250);
	$('.header__search--input').blur(function () { handleAutocomplete(null) });
	$('.header__search--input').keydown(autocompleteEventCallback);

	// UX additional events
	var autocompleteRefreshCallback = function (e /*ignore*/, skipEventHandling) {
		if (!skipEventHandling) {
			var inputSearch = $('.header__search--input');
			var searchTerm = inputSearch.val();
			if (searchTerm && inputSearch.length > 0) {
				openAutocomplete();
				autocompleteEventCallback.call(inputSearch.get(0) /*this*/, { which: 10 /*soft-ENTER*/ });
			}
			// Force focus without triggering any event handler
			skipEventHandling = true;
			$('.header__search--input').trigger('focus', skipEventHandling);
		}
	};
	$('.header__search--input').focus(autocompleteRefreshCallback);
	$('.header__search--before').click(autocompleteRefreshCallback);

	function asyncSearch (query, start, count, successCallback, errorCallback) {
		$.ajax({
			url: "_/service/no.seeds.as/autocompleteService",
			type: "POST",
			dataType: 'json',
			data: { query: query, start: start, count: count },
			success: successCallback,
			error: errorCallback || function (xhr) {
				console.error(xhr.responseText);
			}
		});
	}

	function handleAutocomplete (searchResult) {
		var dfd = $.Deferred();
		try {
			var item;
			var element;
			var anchor;
			// Remove autocomplete rows before adding new results
			$('.header__search-result-row').remove(':not(.hidden)');
			$('.header__search-result--fullpage').prop('href', '#');

			if (!searchResult) {
				$('.header__search-results').addClass('hidden');
			} else {
				// Store it on cache
				searchCache[searchResult.searchTerm] = searchResult;
				var itemList = aux.forceArray(searchResult.itemList);
				// Row template
				var template = $('.header__search-result-row.hidden').first();
				for (var i in itemList) {
					// Fill data for each row and insert into HTML
					item = itemList[i];
					element = template.clone(true, false);
					anchor = element.children('a').first();
					anchor.text(item.title);
					anchor.prop('href', item.url);
					aux.assureAnchorClick(anchor, item.url);
					element.prop('title', $('<span>' + (item.intro || item.title) + '</span>').text());
					element.removeClass('hidden');
					element.insertBefore('.header__search-result--fullpage');
				}
				anchor = $('.header__search-result--fullpage').children('a').first();
				anchor.prop('href', searchResult.fullSearchUrl || '#');
				// Make sure that link is clicked before blur event
				aux.assureAnchorClick(anchor, searchResult.fullSearchUrl);
				$('.header__search-results').removeClass('hidden');
				dfd.resolve({ searchResult: searchResult, fullpageAnchor: anchor });
			}
		} catch (e) {
			dfd.reject({ error: e, searchResult: searchResult });
		}
		return dfd.promise();
	}

	function openAutocomplete (e) {
		var autocompleteInput = $('.header__search:not(.header__search-results)');
		if (autocompleteInput.hasClass('hidden')) {
			$('.header__search--input').val(''); // Clear previous value
			$('.as-nav .menu').addClass('hidden');
			autocompleteInput.removeClass('hidden');
			$('.header__search--input').focus(); // Set focus
		}
		if (e && typeof e.preventDefault === 'function') {
			e.preventDefault();
		}
		return false;
	}

	function closeAutocomplete (e) {
		var autocompleteInput = $('.header__search:not(.header__search-results)');
		if (!autocompleteInput.hasClass('hidden')) {
			handleAutocomplete(null);
			searchCache = {}; // Clear cache
			$('.header__search:not(.header__search-results)').addClass('hidden');
			$('.as-nav .menu').removeClass('hidden');
		}
		if (e && typeof e.preventDefault === 'function') {
			e.preventDefault();
		}
		return false;
	}
})



// WEBPACK FOOTER //
// ./src/main/resources/assets/js/authentic/autocomplete.js